__turbopack_context__.v({
  "backgroundAsset": "HomeHero-module-scss-module__VNfSPa__backgroundAsset",
  "content": "HomeHero-module-scss-module__VNfSPa__content",
  "ctaList": "HomeHero-module-scss-module__VNfSPa__ctaList",
  "hero": "HomeHero-module-scss-module__VNfSPa__hero",
  "heroContainer": "HomeHero-module-scss-module__VNfSPa__heroContainer",
  "mark-magenta": "HomeHero-module-scss-module__VNfSPa__mark-magenta",
  "mark-teal": "HomeHero-module-scss-module__VNfSPa__mark-teal",
  "stack-module-0": "HomeHero-module-scss-module__VNfSPa__stack-module-0",
  "stack-module-1": "HomeHero-module-scss-module__VNfSPa__stack-module-1",
  "stack-module-10": "HomeHero-module-scss-module__VNfSPa__stack-module-10",
  "stack-module-11": "HomeHero-module-scss-module__VNfSPa__stack-module-11",
  "stack-module-12": "HomeHero-module-scss-module__VNfSPa__stack-module-12",
  "stack-module-13": "HomeHero-module-scss-module__VNfSPa__stack-module-13",
  "stack-module-14": "HomeHero-module-scss-module__VNfSPa__stack-module-14",
  "stack-module-15": "HomeHero-module-scss-module__VNfSPa__stack-module-15",
  "stack-module-16": "HomeHero-module-scss-module__VNfSPa__stack-module-16",
  "stack-module-17": "HomeHero-module-scss-module__VNfSPa__stack-module-17",
  "stack-module-18": "HomeHero-module-scss-module__VNfSPa__stack-module-18",
  "stack-module-19": "HomeHero-module-scss-module__VNfSPa__stack-module-19",
  "stack-module-2": "HomeHero-module-scss-module__VNfSPa__stack-module-2",
  "stack-module-20": "HomeHero-module-scss-module__VNfSPa__stack-module-20",
  "stack-module-3": "HomeHero-module-scss-module__VNfSPa__stack-module-3",
  "stack-module-4": "HomeHero-module-scss-module__VNfSPa__stack-module-4",
  "stack-module-5": "HomeHero-module-scss-module__VNfSPa__stack-module-5",
  "stack-module-6": "HomeHero-module-scss-module__VNfSPa__stack-module-6",
  "stack-module-7": "HomeHero-module-scss-module__VNfSPa__stack-module-7",
  "stack-module-8": "HomeHero-module-scss-module__VNfSPa__stack-module-8",
  "stack-module-9": "HomeHero-module-scss-module__VNfSPa__stack-module-9",
  "z-base": "HomeHero-module-scss-module__VNfSPa__z-base",
  "z-content": "HomeHero-module-scss-module__VNfSPa__z-content",
  "z-footer": "HomeHero-module-scss-module__VNfSPa__z-footer",
  "z-header": "HomeHero-module-scss-module__VNfSPa__z-header",
  "z-hero": "HomeHero-module-scss-module__VNfSPa__z-hero",
  "z-logo": "HomeHero-module-scss-module__VNfSPa__z-logo",
  "z-logo-effect": "HomeHero-module-scss-module__VNfSPa__z-logo-effect",
  "z-navigation": "HomeHero-module-scss-module__VNfSPa__z-navigation",
  "z-sub": "HomeHero-module-scss-module__VNfSPa__z-sub",
});
